/**
 * User-facing text for the Backend's department refusal codes
 * (docs/guardian/03 §1.3, 2026-10-21).
 */

export function departmentErrorMessage(res, fallback) {
  switch (res?.data?.code) {
    case 'last_admin':
      return 'A department needs at least one active admin. Make someone else an admin first.';
    case 'seat_limit_reached':
      return 'All seats are in use. Remove or suspend a member, or ask Interlinked for more seats.';
    case 'department_plan_inactive':
      return 'This department has no active Guardian plan.';
    case 'department_admin_required':
      return 'Only department admins can do this.';
    case 'invite_not_pending':
      return 'That invitation is no longer pending.';
    case 'term_exists':
      return 'A term with that code and scope already exists in your glossary.';
    case 'term_conflict':
    case 'structure_conflict':
      return 'Someone else changed this item. Reload and try again.';
    default:
      return res?.message || fallback;
  }
}

